/*=========================================================================================
  File Name: moduleChatActions.js
  Description: Chat Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  // Get chats from server. Also change in store
 async fetchItems({ commit,dispatch  }, event) {
    if (!this.state.account.items[event.userId]) {
      let path = event.userId == 'currentUser' ?
        "/api/services/app/Accounts/GetAccounts?getAll=true"
        : `/api/services/app/Accounts/GetAccountsByUserId?userId=${event.userId}`;
      await axios.get(path)
        .then((response) => {
          let data = {
            items: response.data.result,
            name: event.userId
          }
          commit('UPDATE_Items', data)
        })
        .catch((error) => { });
    }
    const a = this.state.account.items[event.userId].filter(x => x.isMerchant)[0];
    if (event.userId == "currentUser"
      && this.state.account.items[event.userId]
      && this.state.account.items[event.userId].filter(x => x.isMerchant).length == 1) {
      commit('UPDATE_Default', {
        id: a.value,
        text: a.label,
      });
    }
    dispatch("setBalance", { accountId: a.value })
  },
  setDefault({ commit,dispatch }, event) {
      commit('UPDATE_Default', event)
      dispatch("setBalance", { accountId: event.id })
  },
  setBalance({ commit }, event) {
    return new Promise(async (resolve, reject) => {
      const headers = {
        AccountId: event.accountId,
      };
      // Get MyBalance
      axios.get("/api/services/app/Accounts/GetMyBalance", { headers: headers })
        .then((response) => {
          commit('UPDATE_Balance', response.data.result);
        })
        .catch((error) => {
          console.log(error);
        });
    })
  },
}
